import React, { Fragment } from 'react';
import Breadcrumb from '../../components/common/breadcrumb'
import ListDataMapping from './list-data'

const SekolahMapping = () => {
    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="container-fluid p-0">
                    <Breadcrumb title="Talent Mapping Sekolah" parent="English Course" />
                    <div className="row">
                        <div className="col-md-12">
                            <ListDataMapping/>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default SekolahMapping;